import { useTranslation } from 'react-i18next';

export default function FundManagement() {
  const { t } = useTranslation();
  return (
    <section id="fund" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #100b1e 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-50" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Risk Control */}
        <div className="rounded-2xl p-8 mb-12 border border-purple-400/15"
          style={{ background: 'linear-gradient(135deg, rgba(147,51,234,0.08), rgba(124,58,237,0.04))' }}>
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-full bg-purple-400/12 border border-purple-400/22 flex items-center justify-center"
                style={{ boxShadow: '0 0 30px rgba(168,85,247,0.18)' }}>
                <i className="ri-error-warning-fill text-4xl text-purple-400"></i>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-white mb-3 font-heading">{t('fundManagement.riskTitle')}</h3>
              <p className="text-white/50 text-lg leading-relaxed mb-5">
                {t('fundManagement.riskDesc')}
              </p>
              <div className="flex flex-wrap gap-3">
                {[
                  { labelKey: 'fundManagement.stat_maxSingle', valKey: 'fundManagement.stat_maxSingleVal' },
                  { labelKey: 'fundManagement.stat_diversify', valKey: 'fundManagement.stat_diversifyVal' },
                  { labelKey: 'fundManagement.stat_stopLoss', valKey: 'fundManagement.stat_stopLossVal' },
                ].map(item => (
                  <div key={item.labelKey} className="premium-card rounded-lg px-4 py-2.5">
                    <span className="text-sm text-white/35">{t(item.labelKey)}:</span>
                    <span className="ml-2 font-bold text-purple-400">{t(item.valKey)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Risk Data Visualization */}
        <div className="premium-card rounded-2xl p-6 md:p-8">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-8 text-center font-heading">{t('fundManagement.vizTitle')}</h3>
          <div className="space-y-5">
            {[
              { labelKey: 'fundManagement.viz_exposure', pct: 95, val: '95/100' },
              { labelKey: 'fundManagement.viz_diversify', pct: 92, val: '92/100' },
              { labelKey: 'fundManagement.viz_correlation', pct: 88, val: '88/100' },
              { labelKey: 'fundManagement.viz_stability', pct: 94, val: '94/100' },
            ].map(item => (
              <div key={item.labelKey} className="flex items-center gap-4">
                <span className="font-medium text-white/60 w-28 md:w-36 text-sm shrink-0">{t(item.labelKey)}</span>
                <div className="flex-1 h-2 bg-white/5 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${item.pct}%`, background: 'linear-gradient(90deg, #7c3aed, #c084fc)' }}
                  ></div>
                </div>
                <span className="text-purple-400 font-bold w-16 text-right text-sm shrink-0">{item.val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
